'use client';

import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { Styles, css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import { glossaryTermAtom } from '../jotai';

const Breadcrumb = ({ css: cssProp }: { css: Styles }) => {
  const t = useTranslations();
  const glossaryTerm = useAtomValue(glossaryTermAtom);
  if (!glossaryTerm) return;

  return (
    <nav
      aria-label={t('Autogen_common.r251126.s_Breadcrumb')}
      className={css(cssProp, {
        color: 'legacy.gray.8',
      })}
    >
      <ul
        className={hstack({
          gap: 2,
          '& li': {
            textStyle: 'Legacy/SubHead',
            flexBasis: 'auto',
            '&:last-of-type': {
              color: 'white',
            },
            tablet: {
              textStyle: 'Legacy/H4',
            },
          },
          '& a': {
            color: 'currentColor',
            textDecoration: 'none',
            outlineColor: 'transparent',
            '&:focus-visible': { outline: '1px solid', outlineColor: 'legacy.blue' },
          },
        })}
      >
        <li>
          <a href='/'>
            <FormattedMessage id='Autogen_common.r251126.s_Home' />
          </a>
        </li>
        <li>
          <ChevronRightIcon size={18} />
        </li>
        <li>
          <a href='/glossary'>
            <FormattedMessage id='Autogen_common.r251126.s_Glossary' />
          </a>
        </li>
        <li>
          <ChevronRightIcon size={18} />
        </li>
        <li>{glossaryTerm.name}</li>
      </ul>
    </nav>
  );
};

export default Breadcrumb;
